"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ClayTooltipProvider", {
  enumerable: true,
  get: function get() {
    return _TooltipProvider.default;
  }
});
exports.default = void 0;

var _Tooltip = _interopRequireDefault(require("./Tooltip"));

var _TooltipProvider = _interopRequireDefault(require("./TooltipProvider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var _default = _Tooltip.default;
exports.default = _default;